import { render, staticRenderFns } from "./Formx.vue?vue&type=template&id=a4e5e26c"
import script from "./Formx.vue?vue&type=script&lang=js"
export * from "./Formx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports